/* Il cielo di Archimede: disegna un numero a partire dal JSON in #cielo-dati.
   Lo stesso script serve tutti i numeri: ogni mese cambia solo il JSON del metaoggetto. */
(function () {
  "use strict";
  var ridotto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function fonti(lista, prefisso) {
    if (!lista || !lista.length) return "";
    return '<p class="fonte">' + (prefisso || "Fonte") + ": " + lista.map(function (f) {
      return '<a href="' + esc(f.u) + '" target="_blank" rel="noopener">' + esc(f.t) + "</a>";
    }).join(" · ") + "</p>";
  }

  /* ---------- Cielo stellato ---------- */
  function stellato(cv) {
    var cx = cv.getContext("2d"), stelle = [];
    function prepara() {
      var r = cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = r.width * d; cv.height = r.height * d; cx.setTransform(d, 0, 0, d, 0, 0);
      var n = Math.round(r.width * r.height / 2600);
      stelle = [];
      for (var i = 0; i < n; i++) stelle.push({ x: Math.random() * r.width, y: Math.random() * r.height, r: Math.random() * 1.3 + .2, f: Math.random() * 6.28, v: .4 + Math.random() * 1.2, g: Math.random() < .06 });
    }
    function disegna(t) {
      var r = cv.getBoundingClientRect();
      var lin = cx.createLinearGradient(0, 0, 0, r.height);
      lin.addColorStop(0, "#71549F"); lin.addColorStop(.55, "#2a2763"); lin.addColorStop(1, "#0b1026");
      cx.fillStyle = lin; cx.fillRect(0, 0, r.width, r.height);
      var grd = cx.createRadialGradient(r.width * .85, r.height * .1, 0, r.width * .85, r.height * .1, r.width * .7);
      grd.addColorStop(0, "rgba(75,194,239,.45)"); grd.addColorStop(1, "rgba(75,194,239,0)");
      cx.fillStyle = grd; cx.fillRect(0, 0, r.width, r.height);
      for (var i = 0; i < stelle.length; i++) {
        var s = stelle[i];
        cx.globalAlpha = ridotto ? .8 : .55 + .45 * Math.sin(s.f + t / 1000 * s.v);
        cx.fillStyle = s.g ? "#F9B233" : "#eef1ff";
        cx.beginPath(); cx.arc(s.x, s.y, s.r, 0, 6.2832); cx.fill();
      }
      cx.globalAlpha = 1;
      if (!ridotto) requestAnimationFrame(disegna);
    }
    prepara(); requestAnimationFrame(disegna);
    window.addEventListener("resize", function () { prepara(); if (ridotto) disegna(0); });
  }

  /* ---------- Numero ---------- */
  function numero(root, D) {
    var MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
    var meseNome = MESI[D.mese - 1], giorni = new Date(D.anno, D.mese, 0).getDate();
    var C = D.cielo, S = D.losaiche, I = D.illusione, V = D.verofalso, L = D.laboratorio;

    var h = "";
    // indice nell'intestazione
    var voci = [["cielo", "var(--cielo)", C.etichetta], ["losaiche", "var(--sole)", "Lo sai che"], ["illusione", "var(--arancio)", "L'illusione"], ["verofalso", "var(--corallo)", "Vero o falso"], ["laboratorio", "var(--ghiaccio)", "Laboratorio"]];
    root.querySelector("[data-indice]").innerHTML = voci.map(function (v) {
      return '<a href="#' + v[0] + '" style="--c:' + v[1] + '"><small>' + esc(v[2]) + "</small><strong>" + esc(D.indice[v[0]]) + '</strong><span class="nuovo">Nuovo</span></a>';
    }).join("");

    // IL CIELO
    h += '<section class="rub" id="cielo" style="--c:var(--cielo)"><div class="wrap">' +
      '<p class="etichetta">' + esc(C.etichetta) + "</p><h2>" + esc(C.titolo) + '</h2><p class="intro">' + esc(C.intro) + "</p>" +
      '<div class="blocco"><h3>La Luna, giorno per giorno</h3><div class="luna-box"><canvas width="264" height="264" role="img" aria-label="Aspetto della Luna nel giorno scelto" data-luna></canvas>' +
      '<div class="luna-info"><span class="luna-giorno" data-luna-giorno></span><span class="luna-fase" data-luna-fase></span>' +
      '<label for="luna-slider" class="nota">Scorri per cambiare giorno</label><input type="range" id="luna-slider" min="1" max="' + giorni + '" value="1" data-luna-slider>' +
      '<div class="scala-giorni" aria-hidden="true">' + (C.scala_luna || []).map(function (x) { return "<span>" + esc(x) + "</span>"; }).join("") + "</div></div></div>" +
      fonti(C.fonti_luna, "Fasi lunari") + "</div>" +
      '<div class="blocco"><h3>Il calendario degli eventi</h3><ul class="cal" data-cal></ul></div>' +
      '<div class="blocco"><h3>I pianeti di ' + meseNome + '</h3><div class="pianeti">' + C.pianeti.map(function (p) {
        return '<div class="pianeta" style="--p:' + esc(p.colore) + '"><span class="pt"><i></i>' + esc(p.nome) + "</span><p>" + esc(p.testo) + '</p><span class="mono">' + esc(p.dato) + "</span></div>";
      }).join("") + "</div>" + (C.consiglio ? '<p class="consiglio">' + esc(C.consiglio) + "</p>" : "") +
      (C.nota_pianeti ? '<p class="fonte">' + esc(C.nota_pianeti) + "</p>" : "") + fonti(C.fonti_pianeti, "Dati sui pianeti") + "</div></div></section>";

    // LO SAI CHE (domanda può contenere <em>)
    h += '<section class="rub" id="losaiche" style="--c:var(--sole)"><div class="wrap"><p class="etichetta">Lo sai che</p><h2>' + esc(S.titolo) + '</h2><div class="fatti blocco">' +
      S.fatti.map(function (f) {
        return '<article class="fatto"><span class="numerone">' + esc(f.numerone) + '</span><p class="domanda">' + f.domanda + '</p><p class="risposta">' + esc(f.risposta) + "</p>" + fonti(f.fonti) + "</article>";
      }).join("") + "</div></div></section>";

    // ILLUSIONE
    h += '<section class="rub" id="illusione" style="--c:var(--arancio)"><div class="wrap"><p class="etichetta">L\'illusione del mese</p><h2>' + esc(I.titolo) + '</h2><p class="intro">' + esc(I.intro) + '</p><div class="blocco" data-illusione></div>' +
      '<div class="blocco"><h3>' + esc(I.spiegazione_titolo || "Che cosa è successo?") + '</h3><p class="intro">' + esc(I.spiegazione) + "</p>" +
      (I.prova ? '<p class="consiglio" style="--c:var(--arancio)">' + I.prova + "</p>" : "") + fonti(I.fonti) + "</div></div></section>";

    // VERO O FALSO
    h += '<section class="rub" id="verofalso" style="--c:var(--corallo)"><div class="wrap"><p class="etichetta">Vero o falso</p><h2>' + esc(V.titolo) + '</h2><div class="blocco"><div class="quiz" aria-live="polite" data-quiz></div></div></div></section>';

    // LABORATORIO
    h += '<section class="rub" id="laboratorio" style="--c:var(--ghiaccio)"><div class="wrap"><p class="etichetta">Laboratorio</p><h2>' + esc(L.titolo) + '</h2><p class="intro">' + esc(L.intro) + '</p><div class="blocco"><div data-lab></div>' + fonti(L.fonti, "Dati") + "</div></div></section>";

    // PROSSIMO NUMERO E NOTE
    if (D.prossimo) h += '<div class="wrap prossimo"><div class="card-viola"><p class="etichetta" style="--c:var(--sole)">' + esc(D.prossimo.etichetta) + "</p><h2>" + esc(D.prossimo.titolo) + '</h2><p class="intro" style="margin:0;color:#d9ddf5">' + esc(D.prossimo.testo) + "</p></div></div>";
    if (D.note && D.note.length) h += '<div class="wrap note-numero"><ul>' + D.note.map(function (n) { return "<li>" + esc(n) + "</li>"; }).join("") + "</ul></div>";

    root.querySelector("[data-corpo]").innerHTML = h;

    luna(root, D, giorni, meseNome);
    calendario(root, C.eventi, meseNome);
    if (I.tipo === "ponzo") ponzo(root.querySelector("[data-illusione]"));
    quiz(root.querySelector("[data-quiz]"), V.domande, "cielo-" + D.anno + "-" + D.mese);
    if (L.tipo === "pianeti") laboratorioPianeti(root.querySelector("[data-lab]"), L.nota);
    rubricaAttiva(root);
  }

  /* ---------- Luna giorno per giorno ---------- */
  var lunaDisegna = function () {};
  function luna(root, D, giorni, meseNome) {
    var SIN = 29.530588853, NUOVA = Date.parse(D.luna_nuova_utc);
    var lc = root.querySelector("[data-luna]"), lx = lc.getContext("2d"), slider = root.querySelector("[data-luna-slider]");
    function nomeFase(f) {
      if (f < .02 || f > .98) return "Luna nuova";
      if (f < .23) return "Falce crescente";
      if (f < .27) return "Primo quarto";
      if (f < .48) return "Gibbosa crescente";
      if (f < .52) return "Luna piena";
      if (f < .73) return "Gibbosa calante";
      if (f < .77) return "Ultimo quarto";
      return "Falce calante";
    }
    lunaDisegna = function (g) {
      var t = Date.UTC(D.anno, D.mese - 1, g, 20, 0);
      var eta = ((t - NUOVA) / 864e5) % SIN; if (eta < 0) eta += SIN;
      var f = eta / SIN, k = Math.cos(2 * Math.PI * f), illum = (1 - k) / 2;
      var W = lc.width, c = W / 2, r = W / 2 - 10, rx = r * Math.abs(k);
      lx.clearRect(0, 0, W, W);
      lx.fillStyle = "#1b2347"; lx.beginPath(); lx.arc(c, c, r, 0, Math.PI * 2); lx.fill();
      lx.save(); lx.shadowColor = "rgba(249,178,51,.45)"; lx.shadowBlur = 24; lx.fillStyle = "#f4ecd2"; lx.beginPath();
      if (f < .5) {
        lx.arc(c, c, r, -Math.PI / 2, Math.PI / 2, false);
        if (k > 0) lx.ellipse(c, c, rx, r, 0, Math.PI / 2, -Math.PI / 2, true); else lx.ellipse(c, c, rx, r, 0, Math.PI / 2, 3 * Math.PI / 2, false);
      } else {
        lx.arc(c, c, r, Math.PI / 2, 3 * Math.PI / 2, false);
        if (k > 0) lx.ellipse(c, c, rx, r, 0, 3 * Math.PI / 2, Math.PI / 2, true); else lx.ellipse(c, c, rx, r, 0, -Math.PI / 2, Math.PI / 2, false);
      }
      if (illum > .005) lx.fill();
      lx.restore();
      root.querySelector("[data-luna-giorno]").textContent = g + " " + meseNome;
      root.querySelector("[data-luna-fase]").textContent = nomeFase(f) + " · illuminata al " + Math.round(illum * 100) + "%";
      slider.value = g;
    };
    slider.addEventListener("input", function () { lunaDisegna(+slider.value); });
    lunaDisegna(1);
  }

  /* ---------- Calendario ---------- */
  function calendario(root, eventi, meseNome) {
    var ul = root.querySelector("[data-cal]"), sigla = meseNome.slice(0, 3).toUpperCase();
    // Il dettaglio sta fuori dal pulsante, così il testo può contenere link (es. alla rubrica "Lo sai che").
    eventi.forEach(function (e, i) {
      var li = document.createElement("li");
      li.innerHTML = '<button type="button" aria-expanded="false" aria-controls="ev' + i + '"><span class="data"><b>' + e.g + "</b><span>" + sigla + '</span></span><span><span class="ev-tit">' + esc(e.t) + '</span><span class="ev-sub">' + esc(e.s) +
        '</span></span></button><div class="ev-det" id="ev' + i + '" hidden><dl><dt>Quando</dt><dd>' + esc(e.quando) + "</dd><dt>Dove</dt><dd>" + esc(e.dove) + "</dd></dl><p>" + e.testo + "</p></div>";
      var b = li.firstChild;
      b.addEventListener("click", function () {
        var aperto = b.getAttribute("aria-expanded") === "true";
        b.setAttribute("aria-expanded", String(!aperto));
        li.classList.toggle("aperto", !aperto);
        document.getElementById("ev" + i).hidden = aperto;
        if (!aperto) lunaDisegna(e.g);
      });
      ul.appendChild(li);
    });
  }

  /* ---------- Illusione di Ponzo ---------- */
  function ponzo(box) {
    box.innerHTML = '<div class="ponzo"><svg viewBox="0 0 400 300" role="img" aria-label="Due binari che convergono verso l\'alto, con una barra in alto e una in basso">' +
      '<g stroke="#3a4680" stroke-width="3" stroke-linecap="round"><line x1="70" y1="296" x2="186" y2="6"/><line x1="330" y1="296" x2="214" y2="6"/></g><g stroke="#26305e" stroke-width="2" data-trav></g>' +
      '<rect data-alta x="140" y="64" width="120" height="12" rx="3" fill="#FF8647"/><rect x="140" y="228" width="120" height="12" rx="3" fill="#FF8647"/>' +
      '<rect data-fantasma x="140" y="64" width="120" height="12" rx="3" fill="none" stroke="#eef1ff" stroke-width="2" stroke-dasharray="6 4" opacity="0"/></svg>' +
      '<label for="ponzo-slider">Regola la barra in alto finché ti sembra lunga quanto quella in basso</label><input type="range" id="ponzo-slider" min="70" max="170" value="150">' +
      '<div class="azioni"><button type="button" class="btn" style="--c:var(--arancio)" data-verifica>Verifica</button><button type="button" class="btn ghost" data-riprova>Riprova</button></div><p class="esito" aria-live="polite" data-esito></p></div>';
    var tr = box.querySelector("[data-trav]");
    for (var y = 20; y < 296; y += 26) {
      var half = 14 + (y - 6) / 290 * 116, l = document.createElementNS("http://www.w3.org/2000/svg", "line");
      l.setAttribute("x1", 200 - half - 6); l.setAttribute("x2", 200 + half + 6); l.setAttribute("y1", y); l.setAttribute("y2", y);
      tr.appendChild(l);
    }
    var ps = box.querySelector("#ponzo-slider"), alta = box.querySelector("[data-alta]"), fant = box.querySelector("[data-fantasma]"), esito = box.querySelector("[data-esito]"), VERA = 120;
    function agg() { var w = +ps.value; alta.setAttribute("width", w); alta.setAttribute("x", 200 - w / 2); }
    ps.addEventListener("input", function () { agg(); fant.setAttribute("opacity", "0"); esito.textContent = ""; });
    box.querySelector("[data-verifica]").addEventListener("click", function () {
      var w = +ps.value, diff = Math.round((VERA - w) / VERA * 100);
      fant.setAttribute("opacity", "1");
      if (Math.abs(diff) <= 3) esito.innerHTML = "Precisissimo: <b>" + w + "</b> contro " + VERA + ". Hai resistito all'illusione!";
      else if (diff > 0) esito.innerHTML = "La tua barra è lunga <b>" + w + "</b>, quella in basso " + VERA + ". Il tuo cervello ha allungato la barra in alto di circa il <b>" + diff + "%</b>. Il tratteggio mostra la misura vera.";
      else esito.innerHTML = "La tua barra è lunga <b>" + w + "</b>, quella in basso " + VERA + ": l'hai fatta più lunga del " + Math.abs(diff) + "%. Il tratteggio mostra la misura vera.";
    });
    box.querySelector("[data-riprova]").addEventListener("click", function () { ps.value = 150 + Math.round(Math.random() * 16 - 8); agg(); fant.setAttribute("opacity", "0"); esito.textContent = ""; });
    agg();
  }

  /* ---------- Vero o falso ---------- */
  function quiz(box, domande, chiave) {
    var idx = 0, esiti = [];
    function pallini() {
      return '<span class="pallini">' + domande.map(function (_, i) {
        return '<i class="' + (esiti[i] === true ? "ok" : esiti[i] === false ? "no" : "") + (i === idx && esiti[i] === undefined ? " ora" : "") + '"></i>';
      }).join("") + "</span>";
    }
    function mostra() {
      if (idx >= domande.length) return finale();
      var d = domande[idx];
      box.innerHTML = '<div class="quiz-top"><span>Affermazione ' + (idx + 1) + " di " + domande.length + "</span>" + pallini() + '</div><p class="affermazione">' + esc(d.a) + '</p><div class="scelte"><button type="button" data-v="1">VERO</button><button type="button" data-v="0">FALSO</button></div><div class="spiega" hidden></div>';
      box.querySelectorAll(".scelte button").forEach(function (b) { b.addEventListener("click", function () { rispondi(b.getAttribute("data-v") === "1"); }); });
    }
    function rispondi(scelta) {
      var d = domande[idx], giusto = scelta === d.v, bv = box.querySelector('[data-v="1"]'), bf = box.querySelector('[data-v="0"]');
      esiti[idx] = giusto; bv.disabled = bf.disabled = true;
      (d.v ? bv : bf).classList.add("giusta");
      if (!giusto) (scelta ? bv : bf).classList.add("sbagliata");
      box.querySelector(".pallini").outerHTML = pallini();
      var sp = box.querySelector(".spiega");
      sp.innerHTML = '<span class="verdetto ' + (giusto ? "ok" : "no") + '">' + (giusto ? "Esatto! " : "Non proprio. ") + "È " + (d.v ? "vero" : "falso") + ".</span><p>" + esc(d.s) + '</p><p class="fonte">Fonte: <a href="' + esc(d.u) + '" target="_blank" rel="noopener">' + esc(d.f) + '</a></p><div class="azioni"><button type="button" class="btn" style="--c:var(--corallo)">' + (idx < domande.length - 1 ? "Avanti" : "Vedi il risultato") + "</button></div>";
      sp.hidden = false;
      var av = sp.querySelector(".btn"); av.addEventListener("click", function () { idx++; mostra(); }); av.focus({ preventScroll: true });
    }
    function finale() {
      var punti = esiti.filter(Boolean).length, record = 0;
      try { record = +(localStorage.getItem(chiave) || 0); if (punti > record) localStorage.setItem(chiave, punti); } catch (e) {}
      var n = domande.length;
      var msg = punti === n ? "Perfetto: nessuna bufala ti ha fregato." : punti >= n - 2 ? "Ottimo fiuto per le bufale." : punti >= Math.ceil(n / 2) ? "Non male: qualche mito ti ha ingannato, ora sai perché." : "Questi miti sono diffusissimi: adesso hai le risposte per smontarli.";
      box.innerHTML = '<div class="quiz-top"><span>Risultato</span>' + pallini() + '</div><div class="finale"><p class="punti">' + punti + "<span>/" + n + "</span></p><p>" + msg + "</p>" + (record > punti ? '<p class="nota">Il tuo record: ' + record + "/" + n + "</p>" : "") + '<button type="button" class="btn" style="--c:var(--corallo)">Rigioca</button></div>';
      box.querySelector(".btn").addEventListener("click", function () { idx = 0; esiti = []; mostra(); });
    }
    mostra();
  }

  /* ---------- Laboratorio: peso ed età sugli altri pianeti ---------- */
  function laboratorioPianeti(box, nota) {
    // Gravità superficiale (m/s²) e periodo orbitale (giorni): NASA Planetary Fact Sheet
    var corpi = [["Mercurio", 3.7, 88.0], ["Venere", 8.9, 224.7], ["Terra", 9.8, 365.2], ["Luna", 1.6, null], ["Marte", 3.7, 687.0], ["Giove", 23.1, 4331], ["Saturno", 9.0, 10747], ["Urano", 8.7, 30589], ["Nettuno", 11.0, 59800]];
    box.innerHTML = '<div class="lab"><div class="campi"><label for="lab-peso">Peso sulla Terra (kg)<input id="lab-peso" type="number" inputmode="decimal" min="1" max="400" value="70"></label><label for="lab-eta">Età (anni)<input id="lab-eta" type="number" inputmode="decimal" min="1" max="120" value="40"></label></div>' +
      '<div class="tabella"><table class="cielo-tab"><thead><tr><th>Dove</th><th>Peso</th><th>Età</th></tr></thead><tbody></tbody></table></div>' + (nota ? '<p class="nota">' + esc(nota) + "</p>" : "") + "</div>";
    var tb = box.querySelector("tbody"), pIn = box.querySelector("#lab-peso"), eIn = box.querySelector("#lab-eta");
    var nf1 = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 1, minimumFractionDigits: 1 }), nf0 = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 });
    function calcola() {
      var peso = Math.max(0, +pIn.value || 0), eta = Math.max(0, +eIn.value || 0), maxP = peso * 23.1 / 9.8 || 1;
      tb.innerHTML = corpi.map(function (c) {
        var w = peso * c[1] / 9.8, a = c[2] ? eta * 365.2 / c[2] : null;
        var anni = a === null ? "–" : a >= 10 ? nf0.format(a) : nf1.format(a);
        return "<tr" + (c[0] === "Terra" ? ' class="terra"' : "") + "><td>" + c[0] + '</td><td><span class="barra-peso" style="width:' + Math.round(w / maxP * 60) + 'px"></span>' + nf1.format(w) + " kg</td><td>" + anni + "</td></tr>";
      }).join("");
    }
    pIn.addEventListener("input", calcola); eIn.addEventListener("input", calcola); calcola();
  }

  /* ---------- Rubrica attiva nella barra ---------- */
  function rubricaAttiva(root) {
    if (!("IntersectionObserver" in window)) return;
    var links = [].slice.call(root.querySelectorAll("nav.barra a[href^='#']"));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) links.forEach(function (a) { a.classList.toggle("attivo", a.getAttribute("href") === "#" + e.target.id); });
      });
    }, { rootMargin: "-20% 0px -70% 0px" });
    root.querySelectorAll("section.rub").forEach(function (s) { io.observe(s); });
  }

  function avvia() {
    document.querySelectorAll(".cielo .stelle").forEach(stellato);
    document.querySelectorAll(".cielo[data-cielo-numero]").forEach(function (root) {
      var el = root.querySelector("script[data-cielo-dati]");
      if (!el) return;
      try { numero(root, JSON.parse(el.textContent)); }
      catch (e) { root.querySelector("[data-corpo]").innerHTML = '<div class="wrap" style="padding-block:40px"><p>Non riesco a caricare questo numero. Ricarica la pagina; se il problema resta, scrivici.</p></div>'; console.error(e); }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", avvia); else avvia();
})();
